import React from "react";
import '../styles/components/Services.css'

const Services= () => {

    return (
        <>
            <div className='services'>
                <h1>الخدمات</h1>
                <h2>التـي  أقدمهــا</h2>
                <div className='services-div'>
                    <div className='service'>
                        <h1 className="number">01</h1>
                        <h1 className="name">تدريب الشركات</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج</p>
                    </div>
                    <div className='service'>
                        <h1 className="number">02</h1>
                        <h1 className="name">استشارات الأعمال</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج</p>
                    </div>
                    <div className='service'>
                        <h1 className="number">03</h1>
                        <h1 className="name">استشارات الأعمال</h1>
                        <p>وريم ايبسوم دولار سيت أميت كونسيكتيتور أدايبا يسكينج</p>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Services